import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import './styles.scss'

const SubHeader = ({ heading, date, backgroundImg }) => (
  <header
    className={classNames('subheader', {
      'subheader--backgroundimg': backgroundImg,
    })}
  >
    <h1 className="subheader__heading">{heading}</h1>
    <h2 className="subheader__date">{date}</h2>
  </header>
)

SubHeader.propTypes = {
  heading: PropTypes.string.isRequired,
  date: PropTypes.string,
  backgroundImg: PropTypes.bool,
}

SubHeader.defaultProps = {
  date: '',
  backgroundImg: false,
}

export default SubHeader
